import React from "react";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
// import PropTypes from 'prop-types';
import classNames from 'classnames';
import RatingsX from "../shared/RatingsX";
import AsyncAction from '../shared/AsyncAction';
import { cartAddItem } from '../../store/cart';
import Time from "../utils/time2";
import { percentage, daysLeft, daysLeft2 } from "../utils/percentage";
import { url } from '../../services/utils';

const Demo4Banner2 = ({ weeklydeal,cartAddItem }) => {
  const endDate = weeklydeal && weeklydeal.weeklyDeals ? weeklydeal.weeklyDeals.end : null;
  const image = weeklydeal && weeklydeal.images && weeklydeal.images.length > 0 ? weeklydeal.images[0].url : "";
  // const endDate = "2022-07-17 00:00:00";

  return (
    <>
      {weeklydeal && daysLeft2(endDate) >= 0 && (
        <section id="banner-2" className="bg-05 wide-60 banner-section weekly-deal">
          <div className="container">
            <div className="row d-flex align-items-center">
              <div className="col-md-12">
                <div className="banner-2-txt white-color text-center weekly-deal__heading">
                  <span className="weekly-deal__eyebrow">Limited-time package</span>
                  <h3 className="h3-sm">Deal of the Week</h3>
                  <p className="p-sm">Secure a competitive UAE business setup package and save up to 50%.</p>
                </div>
              </div>
            </div>
           
            <div className="row d-flex align-items-center">
              {/* REGISTER FORM */}
              <div className="col-md-5 weekly-deal__media-column">
                <div className="course-data text-center weekly-deal__media">
                  {/* Image */}
                  <Link to={url.product(weeklydeal)}>
                    <span className="weekly-deal__discount-badge">
                      Save {percentage(weeklydeal.salePrice, weeklydeal.offerPrice)}%
                    </span>
                    <img className="img-fluid deal1 " src={image} alt="course-preview" />
                    </Link>
                  {/* Course Price */}
                  <div className="course-data-price bg12 text-center">
                    <span className="weekly-deal__price-label">Special offer price</span>
                    <div className="weekly-deal__prices">
                      <strong>AED {weeklydeal && weeklydeal.offerPrice}</strong>
                      <span className="old-price">AED {weeklydeal && weeklydeal.salePrice}</span>
                    </div>
                    <p className="p-sm weekly-deal__availability">{daysLeft(endDate)}</p>
                   
                    <div className="course-rating clearfix">
                    <RatingsX ratings={weeklydeal.ratings} />
                      <span className="ratr">
                      {weeklydeal.ratings.length} Ratings
                      </span>
                      <p className="p-sm">Earn : 500 Points</p>
                    </div>
                  </div>
                </div>

                <div className="weekly-deal__support-card weekly-deal__support-card--bank">
                  <p className="p-sm">Bank Account Options</p>
                  <img className="img-fluid deal1" src="images/products/bank.jpg" alt="Available bank account options" />
                </div>
              </div>
              {/* END REGISTER FORM */}
              {/* BANNER TEXT */}
              <div className="col-md-7 weekly-deal__content-column">
                <div className="banner-2-txt white-color weekly-deal__content">
                  {/* Title */}
                  <div className="banner-2-txt white-color">
                    <h3 className="h5-sm">
                      {/* {weeklydeal && JSON.stringify(weeklydeal)} */}
                      {weeklydeal && (
                        <Link to={url.product(weeklydeal)} className="weekly-deal__title-link">
                          {weeklydeal.title}
                        </Link>
                      )}
                    </h3>
                  </div>
                  {/* COUNTDOWN ELEMENT */}

                  <div className="countdown">
                    <span className="weekly-deal__countdown-label">Hurry, this offer ends in</span>

                    <div id="clock">
                      <div className="cbox clearfix">
                        <span className="cbox-digit">{Time(`${endDate} 24:00:00`).days}</span> <span className="cbox-txt">Days</span>
                      </div>
                      <div className="cbox clearfix">
                        <span className="cbox-digit">{Time(`${endDate} 24:00:00`).hours}</span> <span className="cbox-txt">Hours</span>
                      </div>
                      <div className="cbox clearfix">
                        <span className="cbox-digit">{Time(`${endDate} 24:00:00`).minutes}</span> <span className="cbox-txt">Minutes</span>
                      </div>
                      <div className="cbox clearfix">
                        <span className="cbox-digit">{Time(`${endDate} 24:00:00`).seconds}</span> <span className="cbox-txt">Seconds</span>
                      </div>
                    </div>
                  </div>

                  <div className="course-data-price text-center">
                    <div className="weekly-deal__offer-stats">
                      <span><strong>{weeklydeal.sold}</strong> packages sold</span>
                      <span><strong>{weeklydeal.views}</strong> people viewed</span>
                    </div>
                    <div className="block-banner__button">
                    <AsyncAction
                        action={() => cartAddItem(weeklydeal)}
                        render={({ run, loading }) => (
                            <React.Fragment>
                                <button
                                    type="button"
                                    onClick={run}
                                    className={classNames('btn btn-lg btn-primary product-card__addtocart', {
                                        'btn-loading': loading,
                                    })}                                                                       
                                >
                                   Buy Now
                                </button>                               
                            </React.Fragment>
                        )}
                    />
                      {/* <span className="btn btn-lg btn-primary">Buy Now</span> */}
                    </div>
                    <p className="weekly-deal__cta-note">Limited availability at this price</p>
                  </div>
                </div>

                <div className="weekly-deal__support-card weekly-deal__support-card--workflow">
                  <p className="p-sm">Simple Application Workflow</p>
                  <img className="img-fluid" src="images/products/workflow2.png" alt="Package application workflow" />
                </div>
                {/* End row */}
              </div>
            </div>
            {/* End row */}
          </div>
          {/* End container */}
        </section>
      )}
    </>
  );
};

const mapDispatchToProps = {
  cartAddItem,  
};



export default connect(null, mapDispatchToProps)(Demo4Banner2);
